import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken , getLoginName,setLoginName,removeLoginName,getLoginPwd,
  setLoginPwd,removeLoginPwd,setLoginCompanyid,removeLoginCompanyid,setIsremeber,removeIsremeber} from '@/utils/auth'
import axios from 'axios'
import service from '@/utils/request'
import qs from 'qs'
import { stat } from 'fs';

const user = {
  state: {
    token: getToken(),
    userInfo:{},
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO:(state,userInfo) => {
      state.userInfo = userInfo
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    
  },

  actions: {
    
    // 登录
    Login({ commit }, userInfo) {
      //debugger
      userInfo.username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(userInfo.username, userInfo.password,userInfo.companyid).then(response => {
          if (typeof (response.access_token) == "undefined") {
            throw new Error('登录时，未获取到数字签名');
          }
          // if (typeof (response.User) == "undefined") {
          //   throw new Error('登录时，未获取到用户信息');
          // }
          // if (typeof (response.Rights) == "undefined") {
          //   throw new Error('登录时，未获取到用户权限');
          // }
          if(userInfo.isremeber)
          {
            setIsremeber(true);
          }
          else
          {           
            removeIsremeber()
          }
          console.log(response.access_token)
          setLoginName(userInfo.username)
          setLoginPwd(userInfo.password)
          setLoginCompanyid(userInfo.companyid)
          setToken(response.access_token)
          commit('SET_TOKEN', response.access_token)
          commit('SET_USERINFO', {"CompanyId":response.CompanyId,"ErpApiCompanyId":response.ErpApiCompanyId,"Dept":response.Dept,"DeptName":response.DeptName,"userName":response.userName,"PName":response.PName})
          commit('SET_ROLES', [])
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        // logout(state.token).then(() => {
        //   removeToken()
        //   //removeLoginName() 用于记住用户名和密码
        //   //removeLoginPwd()  用于记住用户名和密码
        //   commit('SET_TOKEN', '')
        //   commit('SET_USERINFO','')
        //   commit('SET_ROLES', [])
        //   resolve()
        // }).catch(error => {
        //   reject(error)
        // })

          removeToken()
          //removeLoginName() 用于记住用户名和密码
          //removeLoginPwd()  用于记住用户名和密码
          commit('SET_TOKEN', '')
          commit('SET_USERINFO','')
          commit('SET_ROLES', [])
          resolve()
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js